module.exports = __webpack_public_path__ + "static/white_sapphire-997327b15845ceb95b056736af046ff0.svg";